module.exports = __webpack_public_path__ + "img/share-from-square.93498134.svg";